import React from 'react'

import Select from '../../UI/Select/Select'


const SearchProjects = props => {

    const { onChangeState, updateDataForm, onSubmit, loadForm } = props
    const buttonIsLoading = loadForm ? ' is-loading' : ''

    return (
        <div>
            <div className="field has-addons">
                <div className="control is-expanded">
                    <input
                        className="input is-acervo-green is-medium"
                        placeholder="Folio de proyecto, Estado, Municipio, etc..."
                        type="text"
                        name='folio'
                        onChange={e=>updateDataForm(e.target)}
                    />
                </div>
                <div className="control">
                    <button
                        className={'button is-medium is-acervo-dark-green' + buttonIsLoading}
                        onClick={onSubmit}
                    >
                        <span className="icon"><i className='is-acervo-dark-green fa fa-search'></i></span>
                    </button>
                </div>
            </div>
            <fieldset className='fieldset is-acervo-green'>
                <legend>Filtra tu búsqueda</legend>
                <div className='subtitle-1'>Entre más específica sea tu búsqueda, mejores resultados obtendrás</div>
                <div className="columns">
                    <div className="column is-3">
                        <div className="select is-acervo-dark-green is-fullwidth">
                            <Select
                                items={props.years}
                                placeholder='Año'
                                name='year'
                                onChange={e=>updateDataForm(e.target)}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="select is-acervo-dark-green is-fullwidth">
                            <Select
                                items={props.modalities}
                                placeholder='Modalidad'
                                name='modality_id'
                                onChange={e=>updateDataForm(e.target)}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="select is-acervo-dark-green is-fullwidth">
                            <Select
                                items={props.states}
                                placeholder='Estado'
                                name='state_id'
                                onChange={e=>onChangeState(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="select is-acervo-dark-green is-fullwidth">
                            <Select
                                items={props.municipalities}
                                placeholder='Municipio'
                                name='municipality_id'
                                onChange={e=>updateDataForm(e.target)}
                            />
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <div className="control is-expanded">
                            <input
                                name="project_name"
                                className="input is-acervo-green"
                                placeholder="Nombre del proyecto"
                                onChange={e=>updateDataForm(e.target)}
                            />
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-4.5">
                        <div className="control is-expanded">
                            <input
                                name="agency_name"
                                className="input is-acervo-green"
                                placeholder="Nombre de la Instancia"
                                onChange={e=>updateDataForm(e.target)}
                            />
                        </div>
                    </div>
                    <div className="column is-4.5">
                        <div className="control is-expanded">
                            <input
                                name="titular_name"
                                className="input is-acervo-green"
                                placeholder="Titular de la Instancia"
                                onChange={e=>updateDataForm(e.target)}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control">
                            <button
                                className={'button is-button-acervo is-acervo-dark-green is-fullwidth' + buttonIsLoading}
                                onClick={onSubmit}
                            >
                                <span className="icon"><i className='is-acervo-dark-green fa fa-search'></i></span>
                                <span className='text'>BUSCAR</span>
                        </button>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    )
}

export default SearchProjects


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Home/SearchProjects.js